import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tools/major-finder/explore/page.tsx");
